import React from 'react';
import MediaQuery from 'react-responsive';
import EDesignMobile from 'components/organisms/eDesignMobile';
import EDesign from 'components/organisms/eDesign';

const EDesignSection = props => {
  return (
    <div id={'eDesign'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <EDesignMobile data={props} breadcrumbList={props.breadcrumbList} />
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <EDesign data={props} breadcrumbList={props.breadcrumbList} />
      </MediaQuery>
    </div>
  );
};

export default EDesignSection;
